<template>
  <app-card-apontamento-skeleton v-bind="$attrs" v-on="$listeners" :actions="actions"
  @click="$_emitter">
    <template #contrato >

    <div class="cardvisita">
      <div v-if="value.id" class="idvisita"> {{ value.id }} </div>
      <div v-if="value.visdatacriacao">
        {{$_formataData(value.visdatacriacao,'DD/MM/YYYY HH:mm')}}
      </div>
    </div>
    </template>
    <template #detalhe1>
      <div v-if="value.visprodutor"> {{value.visprodutor}} </div>
      <div  v-if="value.vispropriedade"> {{value.vispropriedade}}</div>
      <div v-if="value.viscultura"> {{value.viscultura}}</div>
    </template>
  </app-card-apontamento-skeleton>
</template>

<script>
import moment from 'moment-timezone';
import AppCardApontamentoSkeleton from './Skeleton.vue';

export default {
  name: 'AppCardApontamento',

  components: {
    AppCardApontamentoSkeleton,
  },

  methods: {
    $_formataData(date, mascara) {
      return moment.tz(date, 'America/Sao_Paulo').local().format(mascara);
    },

    $_emitter() {
      this.$emit('innerClick', this.value.id);
    },
  },

  props: {
    value: Object,
    actions: Boolean,
  },
};
</script>

/<style scoped>
#principal{
  display: block;
}

.flex-container {
  display: flex;
}

.flex-container > * {
  margin-right: 3px;
}

.idvisita {
  margin-right: 10px;
}

.cardvisita {
  display: flex;
  flex-wrap: wrap;
}
.status{
    color: rgb(4, 156, 4);
    text-align: right;
    font-weight: bold;
}
</style>
